import React from "react";
import { Toaster as SonnerToaster } from "sonner";

export const Toaster = (props) => (
  <SonnerToaster
    position="top-right"
    richColors
    closeButton
    toastOptions={{
      classNames: {
        toast:
          "rounded-lg border border-border bg-background text-foreground shadow-lg font-sans",
        description: "text-muted-foreground",
        actionButton: "bg-primary text-primary-foreground",
        cancelButton: "bg-muted text-muted-foreground",
      },
    }}
    {...props}
  />
);
